import React from 'react'
import { I1Sedan, I1ElectricalChargingStation } from '@e3dc-react/icons'
import { Box, useTheme, useMediaQuery, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { ProgressDots } from 'src/Components/progress-bar'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),

    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.effectStyles.shadowMain,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4),

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
      gap: theme.spacing(2),
    },
  },
  iconRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  text: {
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      flex: 1,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
    },
  },
}))

/**
 * component to show that a vehicle is connecting to a wallbox
 */
const VehicleConnectingToWallboxIndicator: React.FC = () => {
  const theme = useTheme()
  const { t } = useCustomTranslation()
  const upMd = useMediaQuery(theme.breakpoints.up('md'))
  const { classes } = useStyles()
  const dotCount = upMd ? 7 : 5
  return (
    <Box className={classes.container}>
      <Box className={classes.iconRow}>
        <I1Sedan style={{ width: theme.spacing(6), height: theme.spacing(5) }} />
        <ProgressDots dotCount={dotCount} dotSize={6} />
        <I1ElectricalChargingStation style={{ width: theme.spacing(6), height: theme.spacing(5) }} />
      </Box>
      <Box className={classes.text}>
        <Typography variant="body1">{t('vehicle-integration.vehicle-list.vehicle-connected-to-wallbox')}</Typography>
      </Box>
    </Box>
  )
}

export default VehicleConnectingToWallboxIndicator
